import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../../service/auth.service';

@Component({
    selector: 'app-verify-email-change',
    templateUrl: './verify-email-change.component.html',
    styleUrls: ['./verify-email-change.component.scss'],
    providers: [MessageService],
})
export class VerifyEmailChangeComponent implements OnInit {
    token: string | null = null;
    loading = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private messageService: MessageService,
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.token = params['token'] || null;
            if (this.token) {
                this.authService.clearSessionWithoutRedirect();
            } else {
                if (this.authService.isAuthenticated()) {
                    this.router.navigate(['/notfound']);
                } else {
                    this.router.navigate(['/login']);
                }
            }
        });
    }

    async onConfirm() {
        if (!this.token) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Invalid verification link. Token is missing.',
            });
            return;
        }

        this.loading = true;
        try {
            await this.authService.verifyEmailChange(this.token);
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Your email has been successfully verified. Redirecting to login...',
            });

            setTimeout(() => {
                this.router.navigate(['/login']);
            }, 3000);
        } catch (error: any) {
            let detail =
                'Verification failed. The link may be expired or invalid.';
            if (error.error && error.error.detail) {
                detail = error.error.detail;
            }

            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: detail,
            });
        } finally {
            this.loading = false;
        }
    }

    goToLogin() {
        this.router.navigate(['/login']);
    }
}
